export const ALL_DEALERSHIPS_KEY = 'ALL_DEALERSHIPS';
